import { DivMain, FormDiv, DivTextarea, InputTextarea } from "../style.js";

const FormSection1 = ({ isEditMode, complementosProg, setComplementosProg, isRevisaoMode }) => {
  const handleChange = (field, value) => {
    setComplementosProg((prev) => ({ ...prev, [field]: value }));
  }; 

  return (
    <FormDiv $border={!isRevisaoMode} $flex={true} $overflow={!isRevisaoMode}>
      <DivTextarea>
        <label htmlFor="">
          I. Competências/Habilidades esperadas{" "}
          <span>
            {complementosProg.competencias?.length ?? 0}
            /500
          </span>
        </label>
        <InputTextarea
          tabIndex={1}
          type="text"
          rows={5}
          value={complementosProg.competencias}
          maxLength={500}
          onChange={(e) => handleChange("competencias", e.target.value)}
          disabled={isRevisaoMode}
        />
      </DivTextarea>
      <DivTextarea>
        <label htmlFor="">
          II. Conhecimentos conteúdos
          <span>
            {complementosProg.conhecimento?.length ?? 0}
            /500
          </span>
        </label>
        <InputTextarea
          type="text"
          rows={5}
          tabIndex={2}
          value={complementosProg.conhecimento}
          disabled={isRevisaoMode}
          maxLength={500}
          onChange={(e) => handleChange("conhecimento", e.target.value)}
        />
      </DivTextarea>
      <DivTextarea>
        <label htmlFor="">
          III. Metodologia e procedimentos didáticos
          <span>
            {complementosProg.metodologia?.length ?? 0}
            /500
          </span>
        </label>
        <InputTextarea
          type="text"
          tabIndex={3}
          rows={5}
          value={complementosProg.metodologia}
          disabled={isRevisaoMode}
          maxLength={500}
          onChange={(e) => handleChange("metodologia", e.target.value)}
        />
      </DivTextarea>
      <DivTextarea>
        <label htmlFor="">
          IV. Critérios de avaliação
          <span>
            {complementosProg.criterios?.length ?? 0}
            /500
          </span>
        </label>
        <InputTextarea
          type="text"
          tabIndex={4}
          rows={5}
          value={complementosProg.criterios}
          disabled={isRevisaoMode}
          maxLength={500}
          onChange={(e) => handleChange("criterios", e.target.value)}
        />
      </DivTextarea>
      <DivTextarea>
        <label htmlFor="">
          V. Cronograma das etapas (períodos - atividades)
          <span>
            {complementosProg.cronogramas?.length ?? 0}
            /500
          </span>
        </label>
        <InputTextarea
          type="text"
          rows={5}
          tabIndex={5}
          value={complementosProg.cronogramas}
          disabled={isRevisaoMode}
          maxLength={500}
          onChange={(e) => handleChange("cronogramas", e.target.value)}
        />
      </DivTextarea>
      <DivTextarea>
        <label htmlFor="">
          <p>
            VI. Material de apoio didático para os alunos <small>(opcional)</small>
          </p>
          <span>
            {complementosProg.material_apoio?.length ?? 0}
            /500
          </span>
        </label>
        <InputTextarea
          type="text"
          tabIndex={6}
          rows={5}
          value={complementosProg.material_apoio}
          disabled={isRevisaoMode}
          maxLength={500}
          onChange={(e) => handleChange("material_apoio", e.target.value)}
        />
      </DivTextarea>
      <DivTextarea>
        <label htmlFor="">
          <p>
            VII. Observações para o Aluno <small>(opcional)</small>
          </p>
          <span>
            {complementosProg.orientacoes?.length ?? 0}
            /500
          </span>
        </label>
        <InputTextarea
          type="text"
          rows={5}
          tabIndex={7}
          // placeholder={
          //   isEditMode
          //     ? "Observações para o Aluno."
          //     : "Escreva um texto contendo orientações para os alunos realizarem a progressão."
          // }
          value={complementosProg.orientacoes}
          disabled={isRevisaoMode}
          maxLength={500}
          onChange={(e) => setComplementosProg((prev) => ({ ...prev, orientacoes: e.target.value }))}
        />
      </DivTextarea>
    </FormDiv>
  );
};

export default FormSection1;
